import { render, staticRenderFns } from "./uusi-poissaolo.vue?vue&type=template&id=4225f2d6&scoped=true&"
import script from "./uusi-poissaolo.vue?vue&type=script&lang=ts&"
export * from "./uusi-poissaolo.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-poissaolo.vue?vue&type=style&index=0&id=4225f2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225f2d6",
  null
  
)

export default component.exports